import React, { useEffect, useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Footer from "../../component/Footer";
import "../../assets/new/css/Forum.css";
import "../../assets/new/css/MyDiary.css";
import "../../assets/new/css/SchoolTvChannel.css";
import "../../assets/new/css/library.css";
import "../../assets/new/css/wallet.css";

import user1 from "../../assets/new/images/user/1.jpg";
import user2 from "../../assets/new/images/user/2.jpg";
import user3 from "../../assets/new/images/user/4.jpg";
import BreadCrumbs from "../../component/BreadCrumbs";
import SpinnerCmp from "../../component/SpinnerCmp";

const AuthorizedPerson = () => {
  // Static data for authorized persons
  const staticPersonList = [
    {
      gaurdian_image: user1,
      gaurdian_first_name: "John Doe",
      gaurdian_mobile: "1234567890",
      gaurdian_email: "john.doe@example.com",
      nav: "#"
    },
    {
      gaurdian_image: user2,
      gaurdian_first_name: "Jane Smith",
      gaurdian_mobile: "9876543210",
      gaurdian_email: "jane.smith@example.com",
      nav: "#"
    },
    {
      gaurdian_image: user3,
      gaurdian_first_name: "Robert Johnson",
      gaurdian_mobile: "5551234567",
      gaurdian_email: "robert.j@example.com",
      nav: "#"
    }
  ];

  const [personList, setPersonList] = useState([]);
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    // Simulate API call with timeout
    const timer = setTimeout(() => {
      setPersonList(staticPersonList);
      setIsProcessing(false);
    }, 500); // Simulate network delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper sidebar-icon">
          <div className="page-body" id="container">
            <BreadCrumbs />
            <SpinnerCmp loading={isProcessing} />
            <div className="Forum library">
              <div className="main-section">
                <div className="row">
                  {personList.map((item, index) => (
                    <div className="col-md-4" key={index}>
                      <a href={item.nav}>
                        <div className="d-flex flex-row ps-4 pe-1 py-3 align-items-center my-1 shadow-sm cardFeed">
                          <div>
                            <img
                              src={item.gaurdian_image}
                              alt="Authorized person"
                              className="rounded-circle"
                              style={{ height: "58px", width: "58px" }}
                            />
                          </div>
                          <div className="d-flex flex-column ps-3">
                            <small className="route-title">
                              {item.gaurdian_first_name}
                            </small>
                            <small className="route-title">
                              {item.gaurdian_mobile}
                            </small>
                            <small className="route-title">
                              {item.gaurdian_email}
                            </small>
                          </div>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AuthorizedPerson;